import React from 'react'
import { Col, Row } from 'reactstrap'

import '../../standardkomponenter/trekkspill.css'
import { Ar, Fylke } from './RapportFilterInnhold'

import './rapportFilter.css'

export default class RapportFilter extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Row className="rapport-filter">
                <Col className="rapport-filter__felt" xs="12" lg="12" xl="12">
                    <Ar />
                </Col>
                <Col className="rapport-filter__felt" xs="12" lg="12" xl="12">
                    <Fylke />
                </Col>
            </Row>
        )
    }
}
